import { createStore } from "vuex";
import { members } from "./members.module";
import { offers } from "./offers.module";

export default createStore({
    modules:{
        members,
        offers

    }

});